import { ReactNode } from "react";
export type FaqItem = {
  question: string;
  answer: ReactNode;
};
export const FAQ_ITEMS: FaqItem[] = [{
  question: "What is Signature Stay Collection by Whimstay?",
  answer: <>
        <p>
          Signature Stays gives travel advisors access to hundreds of thousands
          of professionally managed vacation homes worldwide, all fully
          commissionable.
        </p>
        <p>
          It&apos;s built on Whimstay&apos;s trusted network, but designed
          specifically for advisors.
        </p>
      </>
}, {
  question: "What kinds of properties are available?",
  answer: <>
        <p>A wide range of professionally managed homes, including:</p>
        <ul className='ml-6 list-disc'>
          <li>Condos and cabins</li>
          <li>Beachfront homes</li>
          <li>Luxury villas</li>
        </ul>
        <p>
          Available across top destinations in the U.S. and more than 80
          countries.
        </p>
      </>
}, {
  question: "How much commission do I earn?",
  answer: <p>You earn a default 10% commission on every booking.</p>
}, {
  question: "Can I adjust my commission?",
  answer: <p>
        Yes. You have flexibility to increase or decrease your commission
        depending on how you want to price and position the stay for your
        client.
      </p>
}, {
  question: "When do I get paid?",
  answer: <p>Commission is paid 30 days after check-in via direct deposit (ACH).</p>
}, {
  question: "Do I see my earnings upfront?",
  answer: <p>
        Yes. Your commission is clearly displayed at the time of booking, so you
        always know what you&apos;ll earn.
      </p>
}, {
  question: "Can I track my bookings and payments?",
  answer: <p>
        Yes. You&apos;ll have access to tools that let you track bookings,
        commissions, and payouts in one place.
      </p>
}, {
  question: "Do I book for my client, or do they book themselves?",
  answer: <>
        <p>Both options work.</p>
        <ul className='ml-6 list-disc'>
          <li>Book directly on behalf of your client</li>
          <li>Or send a link so they can book themselves</li>
        </ul>
        <p>Either way, you earn commission.</p>
      </>
}, {
  question: "If my client books themselves, do I still earn commission?",
  answer: <p>
        Yes. As long as they book through your shared link, you receive full
        commission.
      </p>
}, {
  question: "Are these the same homes found on other platforms?",
  answer: <p>
        In some cases, yes. The difference is that all homes in Signature Stays
        are professionally managed and vetted for quality and reliability.
      </p>
}, {
  question: "Can I use this for higher-end clients?",
  answer: <p>
        Absolutely. The collection includes a wide range of premium and luxury
        properties, making it easy to serve high-end travelers.
      </p>
}, {
  question: "Is there a cost to join?",
  answer: <p>No. Joining is completely free.</p>
}, {
  question: "Who handles issues during the stay?",
  answer: <>
        <p>
          The property manager is the primary point of contact during the stay.
        </p>
        <p>
          If additional support is needed, our team is always available to help.
        </p>
      </>
}, {
  question: "What happens if a client needs to cancel?",
  answer: <>
        <p>
          Cancellation policies vary by property and are clearly outlined before
          booking.
        </p>
        <p>
          If you need help, our support team can guide you through the process.
        </p>
      </>
}];